import React from 'react'
import { defineMessage, FormattedMessage } from 'react-intl'

import {
  BENEFIT_ID,
  CUSTOMER_CORE_BENEFIT_CATEGORY,
} from '@lyrahealth-inc/shared-app-logic/src/features/benefits/types'
import { TREATMENT_OPTIONS } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentOptions'
import { TREATMENT_RECOMMENDATION_TIER } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentRecommendationsConstants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { openUrl } from '../utils/expo-linking'

export const wellspan: GetCustomerCopyFunc = () => {
  const wellSpanEAPProvidersUrl = 'https://sites.google.com/lyrahealth.com/wellspanhealth/eapproviders'
  const wellSpanEAPProvidersName = 'WellSpan EAP Providers'
  const wellSpanEAPAnalyticsName = 'Wellspan EAP'
  const carelonUrl = 'http://wellspan.carelonbh.com'
  const wellSpanEAPProvidersTitle = defineMessage({
    defaultMessage: 'WellSpan EAP Providers',
    description: 'Title for WellSpan EAP Providers',
  })
  const wellSpanEAPProvidersDescription = defineMessage({
    defaultMessage:
      'Access confidential support for personal, family, workplace, or emotional well-being through the WellSpan Employee Assistance Program (EAP).',
    description: 'Description for WellSpan EAP Providers',
  })
  const wellSpanEAPProvidersConfiguration = {
    analyticsName: wellSpanEAPAnalyticsName,
    title: <FormattedMessage {...wellSpanEAPProvidersTitle} />,
    description: <FormattedMessage {...wellSpanEAPProvidersDescription} />,
    modalDescription: (
      <FormattedMessage
        defaultMessage='The WellSpan Employee Assistance Program (EAP) provides confidential support for personal, family, workplace, and emotional well-being concerns. Eligible team members and family members have access to 6 no-cost coaching or therapy sessions per person, per year.'
        description='Modal description for WellSpan EAP Providers'
      />
    ),
    buttonText: (
      <FormattedMessage
        defaultMessage='Learn more'
        description='Button text to learn more about WellSpan EAP Providers'
      />
    ),
    url: wellSpanEAPProvidersUrl,
    isUrlExternal: true,
  }

  return {
    coreBenefits: [
      {
        analyticsName: wellSpanEAPAnalyticsName,
        category: CUSTOMER_CORE_BENEFIT_CATEGORY.CUSTOMER_OFFERING,
        description: wellSpanEAPProvidersDescription,
        testID: 'wellSpanEAPProviders',
        title: wellSpanEAPProvidersTitle,
        url: wellSpanEAPProvidersUrl,
      },
      {
        analyticsName: 'Carelon',
        category: CUSTOMER_CORE_BENEFIT_CATEGORY.BEHAVIORAL_HEALTH,
        description: defineMessage({
          defaultMessage:
            'Access Carelon Behavioral Health to manage your claims, specialty outpatient services, and hospital-based care coordination.',
          description: 'Description of the Carelon Behavioral Health benefit for WellSpan members',
        }),
        testID: BENEFIT_ID.CARELON,
        title: defineMessage({
          defaultMessage: 'Carelon Behavioral Health',
          description: 'Title of the Carelon Behavioral Health benefit for WellSpan members',
        }),
        url: carelonUrl,
      },
    ],
    customForkedTriageOptions: [
      {
        label: wellSpanEAPProvidersName,
        analyticsName: wellSpanEAPAnalyticsName,
        onPress: () => openUrl(wellSpanEAPProvidersUrl),
        minAge: 13,
      },
    ],
    treatmentOptions: [
      {
        option: TREATMENT_OPTIONS.ONSITE_THERAPY,
        config: { customCopy: wellSpanEAPProvidersConfiguration, actingSearcherMinAge: 13 },
        optionRanking: {
          [TREATMENT_RECOMMENDATION_TIER.TIER_2]: 2,
          [TREATMENT_RECOMMENDATION_TIER.TIER_3]: 1,
        },
      },
    ],
  }
}
